/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.AmzPitPupMedical
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const msdQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.MsdAssessmentUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.MsdAssessmentUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfNeck,
        questionText: "Neck",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfBack,
        questionText: "Back",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftShoulder,
        questionText: "Left Shoulder",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftElbow,
        questionText: "Left Elbow",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightShoulder,
        questionText: "Right Shoulder",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightElbow,
        questionText: "Right Elbow",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftWrist,
        questionText: "Left Wrist",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftLeg,
        questionText: "Left Leg",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightWrist,
        questionText: "Right Wrist",
        medicalTypes
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightLeg,
        questionText: "Right Leg",
        medicalTypes
    },
    {
        id: questionIds.DoRestrictionsAffectPerformance,
        questionText: "Do any restrictions affect the performance of your role?",
        medicalTypes
    },
    {
        id: questionIds.DoRestrictionsAffectPerformanceNotes,
        questionText: "Details/Note",
        medicalTypes
    },
];
/* eslint-enable max-len */
